import { getRoute } from "@/utils/utils";

const escapeHtml = (text: string) => text
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#x27;')

/**
 * texte de consentement envoyé avec les formulaires, en HTML.
 * Construit à la main : react-dom/server (renderToString) pèse ~60 KB gzip dans le bundle client.
 */
export const getConsentText = (nom = '') =>
  `J’accepte que mes données soient utilisées par ${escapeHtml(nom)} pour répondre à ma demande, conformément à la <a href="${getRoute({key: 'privacy-policy'})}">Politique de confidentialité.</a>,`
